export const computeMenusKpis = (eventosFiltrados) => {
    const arr = Array.isArray(eventosFiltrados) ? eventosFiltrados : [];
    return {
        eventos: arr.length,
        menusTotales: arr.reduce((s, ev) => s + (ev?.menus?.length || 0), 0),
    };
};
